// extracted by mini-css-extract-plugin
export default {"resetButton":"LiMElmw","prependCell":"a7lo4EZ","icon":"KU2dgKC"};